export const companyName="OVA2 Consultants Pvt. Ltd.";

